import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppThunkApiConfig} from '../../createStore';
import {mapiqApi} from '@lib/infrastructure';
import {CustomerBranding} from '..';

export const getCustomerBranding = createAsyncThunk<CustomerBranding, void, AppThunkApiConfig>(
  'buildings/getCustomerBranding',
  async (_, {extra}) => {
    const api = mapiqApi(extra.apiClient);
    const mySubscription = await api.getMySubscription();

    // no need to fire request for images if there is no displayName
    if (!mySubscription.displayName) return {title: ''};

    const promises = [];
    const logoPromise = api.getSubscriptionImages(mySubscription.logoHash, 'logo');
    const backgroundPromise = api.getSubscriptionImages(mySubscription.backgroundHash, 'background');

    promises.push(mySubscription.logoHash ? logoPromise : undefined);
    promises.push(mySubscription.backgroundHash ? backgroundPromise : undefined);

    const results = await Promise.allSettled(promises);

    const logoBase64 =
      results[0]?.status === 'fulfilled' && results[0].value ? getBase64ImgUrl(results[0].value) : undefined;
    const backgroundBase64 =
      results[1]?.status === 'fulfilled' && results[1].value ? getBase64ImgUrl(results[1].value) : undefined;

    const response = {
      bannerUrl: backgroundBase64,
      logoUrl: logoBase64,
      title: mySubscription.displayName,
    };

    return response;
  },
);

const getBase64ImgUrl = (base64: string, extension = 'png') => `data:image/${extension};base64,${base64}`;
